
import {createSlice} from "@reduxjs/toolkit";

export const productSlice = createSlice({
    name: 'productSlc',
    initialState: {value: {id: null, externalId: null, name: null, episodeName: null,
            seasonExternalId: null, season: null, seasonName: null, seriesExternalId: null,
            seriesName: null,derivativeOfProductId:null,derivativeOfSeriesId:null,photoStartDate:null,
            lengthMinutes: null, m4mktGroup: null, initMkt: null, genre: null, productionType: null,
            broadcastsPerWeek: null, budget: null, productionCost: null, producer: null, financialCode: null,
            eidr: null,
            createdOn: null,createdBy:null,lastModifiedOn:null,lastModifiedBy:null,coveredProduct: null,
            productDrawerState: false, productDrawerMode: null, productGridRefresh: false,
            productSearchState: false, guildMultiSelectState: false, bulkState: false
        }},
    reducers:

{
    changeProduct: (state, action) => {
        state.value = {
            ...state.value,  // Keep existing fields
            ...action.payload // Merge new values
        };
    }
}
});

export const { changeProduct } = productSlice.actions;

export default  productSlice.reducer ;
